export default (array: Array<string>) => {
  if (array.length > 1) {
   const tempArray = array.filter(item => item !== '')
   tempArray.length || tempArray.push('')
   return tempArray
  } else {
    return array
  }
}
